import { proposalConstants } from '../Constants';

const proposal = (proposal) => {
  return {
    type: proposalConstants.PROPOSALS_SUCCESS,
    payload: proposal
  }
}

export const proposalActions = {
  proposal
};